<template>
    <div class="hotel-index-page">
        <canvas id="particles-canvas" class="particles-canvas"></canvas>

        <!-- 导航 -->
        <header class="header" :class="{ scrolled: scrollFlag }">
            <div class="nav-inner">
                <div class="logo">武汉奋煊人力资源有限公司</div>
                <nav class="nav-menu">
                    <a href="#home">首页</a>
                    <a href="#advantage">核心优势</a>
                    <a href="#service">派遣服务</a>
                    <a href="#process">合作流程</a>
                    <a href="#contact">联系我们</a>
                    <el-button class="btn-gold" @click="openDialog('hotel')">酒店合作咨询</el-button>
                </nav>
            </div>
        </header>

        <!-- Banner轮播区域 -->
        <div class="banner" id="home">
            <el-carousel class="banner-carousel" :interval="5000" arrow="never">
                <el-carousel-item class="banner-carousel-item"
                    :style="{ backgroundImage: 'url(' + require('@/assets/imageback/01.jpg') + ')' }"></el-carousel-item>
                <el-carousel-item class="banner-carousel-item"
                    :style="{ backgroundImage: 'url(' + require('@/assets/imageback/02.jpg') + ')' }"></el-carousel-item>
                <el-carousel-item class="banner-carousel-item"
                    :style="{ backgroundImage: 'url(' + require('@/assets/imageback/03.jpg') + ')' }"></el-carousel-item>
            </el-carousel>

            <div class="banner-mask"></div>
            <div class="banner-content-wrap">
                <div class="container">
                    <div class="banner-content animate-item">
                        <h1>高端酒店劳务派遣解决方案<br>为<span class="spangold">星级酒店</span>提供稳定人力支持</h1>
                        <p>专注五星级酒店、精品酒店、度假村人力资源外包。提供客房、前厅、宴会、后厨、安保等全岗位派遣服务，帮助酒店降低用工风险、提升服务效率。</p>
                        <div class="banner-buttons">
                            <el-button class="btn-gold" @click="openDialog('hotel')">获取定制方案</el-button>
                            <el-button class="btn-outline" @click="openDialog('job')">求职者报名</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 核心优势 -->
        <section id="advantage">
            <div class="container">
                <div class="section-title animate-item">
                    <h2>核心优势</h2>
                    <div class="line"></div>
                    <p>以标准化培训和成熟管理体系，服务高端酒店人力需求</p>
                </div>
                <div class="advantage-grid">
                    <div class="card animate-item">
                        <div class="icon">📜</div>
                        <h3>正规劳务资质</h3>
                        <p>持有劳务派遣经营许可证，合规签订劳务协议，统一处理社保、工伤、劳务纠纷，降低酒店用工风险。</p>
                    </div>
                    <div class="card animate-item">
                        <div class="icon">🏨</div>
                        <h3>酒店服务标准培训</h3>
                        <p>参照高端酒店服务规范进行岗前培训，客房、礼仪、宴会服务统一考核后上岗。</p>
                    </div>
                    <div class="card animate-item">
                        <div class="icon">⚡</div>
                        <h3>旺季快速补人</h3>
                        <p>节假日、大型宴会、临时客流高峰可快速调配成熟人员，缓解酒店短期人力压力。</p>
                    </div>
                    <div class="card animate-item">
                        <div class="icon">🔄</div>
                        <h3>灵活用工模式</h3>
                        <p>支持长期派遣、短期临时工、整楼层外包、项目驻场等多种合作方式，按需定制方案。</p>
                    </div>
                    <div class="card animate-item">
                        <div class="icon">👥</div>
                        <h3>成熟人才储备</h3>
                        <p>长期积累酒店服务行业人员，建立稳定人才库，减少酒店重复招聘和培训成本。</p>
                    </div>
                    <div class="card animate-item">
                        <div class="icon">🛠️</div>
                        <h3>专人现场管理</h3>
                        <p>负责人员考勤、日常管理、问题反馈和人员替换，减轻酒店HR管理负担。</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 派遣服务 -->
        <section id="service">
            <div class="container">
                <div class="section-title animate-item">
                    <h2>派遣服务项目</h2>
                    <div class="line"></div>
                    <p>覆盖酒店运营核心岗位，提供稳定、规范的人力支持</p>
                </div>
                <div class="service-grid">
                    <div class="card animate-item">
                        <h4>客房服务员派遣</h4>
                        <p>客房服务员、楼层管家、公区保洁，支持长期用工和旺季临时支援。</p>
                    </div>
                    <div class="card animate-item">
                        <h4>前厅礼宾人员</h4>
                        <p>前台接待、礼宾、大堂助理、门岗服务人员，适配高端酒店形象要求。</p>
                    </div>
                    <div class="card animate-item">
                        <h4>宴会会展服务</h4>
                        <p>婚宴、商务会议、大型活动临时服务员、吧台协助、现场服务支持。</p>
                    </div>
                    <div class="card animate-item">
                        <h4>后厨辅助人力</h4>
                        <p>帮厨、洗碗工、后厨保洁、厨工助理，满足酒店后厨稳定运转需求。</p>
                    </div>
                    <div class="card animate-item">
                        <h4>安保运维人员</h4>
                        <p>酒店门岗、停车场安保、夜间值守、公共区域秩序维护人员。</p>
                    </div>
                    <div class="card animate-item">
                        <h4>整体劳务外包</h4>
                        <p>酒店后勤板块、整楼层、区域人力托管，一站式外包解决方案。</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 合作流程 -->
        <section id="process">
            <div class="container">
                <div class="section-title animate-item">
                    <h2>合作流程</h2>
                    <div class="line"></div>
                    <p>从需求沟通到人员上岗，建立标准化服务闭环</p>
                </div>
                <div class="flow-wrap">
                    <div class="flow-item animate-item">
                        <div class="flow-num">1</div>
                        <h4>需求沟通</h4>
                        <p>确认岗位、人数、服务标准、用工周期</p>
                    </div>
                    <div class="flow-item animate-item">
                        <div class="flow-num">2</div>
                        <h4>方案报价</h4>
                        <p>根据酒店需求定制派遣方案与报价</p>
                    </div>
                    <div class="flow-item animate-item">
                        <div class="flow-num">3</div>
                        <h4>人员筛选</h4>
                        <p>匹配候选人，酒店参与面试筛选</p>
                    </div>
                    <div class="flow-item animate-item">
                        <div class="flow-num">4</div>
                        <h4>岗前培训</h4>
                        <p>服务礼仪、规范流程、酒店制度培训</p>
                    </div>
                    <div class="flow-item animate-item">
                        <div class="flow-num">5</div>
                        <h4>上岗跟进</h4>
                        <p>现场管理、人员调换、问题响应</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 表单区域 -->
        <section id="contact">
            <div class="container">
                <div class="form-section animate-item">
                    <div class="form-row">
                        <div class="form-row-item">
                            <div class="form-title">酒店甲方合作咨询</div>
                            <el-form :model="hotelForm" label-width="95px">
                                <el-form-item label="酒店名称">
                                    <el-input v-model="hotelForm.hotelName"></el-input>
                                </el-form-item>
                                <el-form-item label="对接人">
                                    <el-input v-model="hotelForm.contact"></el-input>
                                </el-form-item>
                                <el-form-item label="联系电话">
                                    <el-input v-model="hotelForm.phone"></el-input>
                                </el-form-item>
                                <el-form-item label="用工需求">
                                    <el-input v-model="hotelForm.demand" type="textarea" rows="4"></el-input>
                                </el-form-item>
                                <el-button class="form-row-item_btn" @click="submitHotelForm">提交咨询</el-button>
                            </el-form>
                        </div>
                        <div class="form-row-item">
                            <div class="form-title">求职者报名通道</div>
                            <el-form :model="jobForm" label-width="95px">
                                <el-form-item label="姓名">
                                    <el-input v-model="jobForm.name"></el-input>
                                </el-form-item>
                                <el-form-item label="手机号码">
                                    <el-input v-model="jobForm.mobile"></el-input>
                                </el-form-item>
                                <el-form-item label="意向岗位">
                                    <el-select v-model="jobForm.post" placeholder="选择岗位" style="width: 100%;">
                                        <el-option label="客房服务员" value="客房服务员"></el-option>
                                        <el-option label="前台/礼宾" value="前台礼宾"></el-option>
                                        <el-option label="宴会服务员" value="宴会服务员"></el-option>
                                        <el-option label="后厨辅助" value="后厨辅助"></el-option>
                                        <el-option label="安保保洁" value="安保保洁"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="工作类型">
                                    <el-radio-group v-model="jobForm.workType">
                                        <el-radio label="全职"></el-radio>
                                        <el-radio label="兼职"></el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-button class="form-row-item_btn" @click="submitJobForm">提交报名</el-button>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 底部 -->
        <footer>
            <div class="container">
                <div class="footer-grid">
                    <div class="footer-col">
                        <h3>武汉<span>奋煊</span>人力资源有限公司</h3>
                        <p>专注高端星级酒店劳务派遣、劳务外包与灵活用工解决方案，为酒店提供规范、稳定、高效的人力支持。</p>
                    </div>
                    <div class="footer-col">
                        <h3>快速导航</h3>
                        <a href="#advantage">核心优势</a>
                        <a href="#service">派遣服务</a>
                        <a href="#process">合作流程</a>
                        <a href="#contact">联系我们</a>
                    </div>
                    <div class="footer-col">
                        <h3>联系方式</h3>
                        <p>联系电话：13487086753</p>
                        <p>公司地址：武汉市汉阳区江城大道与四新南路交叉口东北角华发四季二期办公居住综合楼 21 层办公（14）号
                        </p>
                    </div>
                </div>
                <div class="copyright">©2026 武汉奋煊人力资源有限公司 版权所有 | 鄂ICP备XXXXXX号</div>
            </div>
        </footer>

        <!-- 悬浮工具 -->
        <div class="float-tool">
            <div class="float-btn" title="电话咨询">☎️</div>
            <div class="float-btn" title="微信沟通">💬</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HotelIndex',
    data() {
        return {
            scrollFlag: false,
            hotelForm: {
                hotelName: "",
                contact: "",
                phone: "",
                demand: ""
            },
            jobForm: {
                name: "",
                mobile: "",
                post: "",
                workType: "全职"
            },
            observer: null,
            particles: [],
            animationId: null
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
        this.scrollAnimation()
        this.initParticles()
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll)
        if (this.observer) {
            this.observer.disconnect()
            this.observer = null
        }
        if (this.animationId) {
            cancelAnimationFrame(this.animationId)
        }
    },
    methods: {
        handleScroll() {
            this.scrollFlag = window.scrollY > 60
        },
        scrollAnimation() {
            if (!this.observer) {
                this.observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                entry.target.classList.add('animate-visible')
                            }
                        })
                    },
                    {
                        threshold: 0.15,
                        rootMargin: '0px 0px -80px 0px'
                    }
                )

                const items = document.querySelectorAll('.animate-item')
                items.forEach((el) => this.observer.observe(el))
            }
        },
        openDialog(type) {
            this.$message.info("请下滑填写表单提交需求")
        },
        submitHotelForm() {
            this.$message.success("咨询信息提交成功，我们将尽快联系您！")
        },
        submitJobForm() {
            this.$message.success("求职报名提交成功，等待工作人员联系！")
        },
        initParticles() {
            const canvas = document.getElementById('particles-canvas')
            if (!canvas) return

            const ctx = canvas.getContext('2d')
            canvas.width = window.innerWidth
            canvas.height = window.innerHeight

            const particleCount = 80
            this.particles = []

            for (let i = 0; i < particleCount; i++) {
                this.particles.push({
                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    size: Math.random() * 2 + 0.5,
                    speedX: (Math.random() - 0.5) * 0.5,
                    speedY: (Math.random() - 0.5) * 0.5,
                    opacity: Math.random() * 0.5 + 0.2
                })
            }

            this.animateParticles(canvas, ctx)

            window.addEventListener('resize', () => {
                canvas.width = window.innerWidth
                canvas.height = window.innerHeight
            })
        },
        animateParticles(canvas, ctx) {
            ctx.clearRect(0, 0, canvas.width, canvas.height)

            this.particles.forEach((particle, i) => {
                particle.x += particle.speedX
                particle.y += particle.speedY

                if (particle.x < 0 || particle.x > canvas.width) particle.speedX *= -1
                if (particle.y < 0 || particle.y > canvas.height) particle.speedY *= -1

                ctx.beginPath()
                ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2)
                ctx.fillStyle = `rgba(184, 148, 104, ${particle.opacity})`
                ctx.fill()

                for (let j = i + 1; j < this.particles.length; j++) {
                    const dx = particle.x - this.particles[j].x
                    const dy = particle.y - this.particles[j].y
                    const distance = Math.sqrt(dx * dx + dy * dy)

                    if (distance < 150) {
                        ctx.beginPath()
                        ctx.strokeStyle = `rgba(184, 148, 104, ${0.15 * (1 - distance / 150)})`
                        ctx.lineWidth = 0.5
                        ctx.moveTo(particle.x, particle.y)
                        ctx.lineTo(this.particles[j].x, this.particles[j].y)
                        ctx.stroke()
                    }
                }
            })

            this.animationId = requestAnimationFrame(() => this.animateParticles(canvas, ctx))
        }
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "PingFang SC", "Microsoft YaHei", system-ui, -apple-system, sans-serif;
}

html {
    scroll-behavior: smooth;
}

:root {
    --primary: #1A3446;
    --secondary: #2C3E50;
    --gold: #B89468;
    --gold-light: #D4AF70;
    --dark-bg: #0F172A;
    --card-bg: rgba(255, 255, 255, 0.045);
    --text: #F7F9FA;
    --text-secondary: #B8C2D0;
    --border: rgba(184, 148, 104, 0.15);
}

.hotel-index-page {
    background: linear-gradient(135deg, #0F172A 0%, #1C2D41 100%);
    color: var(--text);
    line-height: 1.6;
}

.container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
    color: #fff;
}

/* 顶部导航 */
.header {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    transition: 0.4s ease;
    background: #ffffff77;
}

.header.scrolled {
    background: rgba(15, 23, 42, 0.88);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--border);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.35);
}

.nav-inner {
    max-width: 1280px;
    margin: 0 auto;
    height: 72px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
    color: #fff;
}

.logo span {
    color: var(--gold);
}

.nav-menu {
    display: flex;
    gap: 32px;
    align-items: center;
}

.nav-menu a {
    color: var(--text-secondary);
    text-decoration: none;
    font-size: 15px;
    position: relative;
    transition: 0.3s;
}

.nav-menu a:hover {
    color: var(--gold);
}

.nav-menu a::after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    left: 50%;
    bottom: -6px;
    background: var(--gold);
    transition: 0.3s;
    transform: translateX(-50%);
}

.nav-menu a:hover::after {
    width: 100%;
}

.btn-gold {
    background: linear-gradient(135deg, #B89468, #D4AF70);
    color: #000 !important;
    border: none;
    border-radius: 4px;
    padding: 10px 22px;
    font-weight: 600;
    transition: 0.3s;
}

.btn-gold:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(184, 148, 104, 0.35);
}

.btn-outline {
    border: 1px solid var(--gold);
    color: var(--gold);
    /* background: transparent; */
    background: linear-gradient(135deg, #689bb8, #708bd4);
    border-radius: 4px;
    padding: 10px 22px;
    font-weight: 500;
    transition: 0.3s;
}

.btn-outline:hover {
    background: rgba(184, 148, 104, 0.08);
    box-shadow: 0 0 15px rgba(184, 148, 104, 0.25);
}

/* ========== Banner 轮播 ========== */
.banner {
    min-height: 100vh;
    padding-top: 72px;
    position: relative;
    overflow: hidden;
}

.banner-carousel {
    position: absolute !important;
    width: 100%;
    height: 99vh;
    top: 0;
    left: 0;
    z-index: 1;
}

::v-deep .banner-carousel .el-carousel__container {
    height: 100%;
}

.banner-carousel-item {
    width: 100%;
    height: 99vh;
    background-size: cover;
    background-position: center;
}

.banner-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.55);
    z-index: 2;
}

.banner-content-wrap {
    position: relative;
    z-index: 3;
    height: 100vh;
    display: flex;
    align-items: center;
    padding-top: 72px;
}

.banner-content {
    max-width: 680px;
}

.banner-content h1 {
    font-size: 48px;
    line-height: 1.3;
    margin-bottom: 20px;
}

.banner-content h1 span {
    color: var(--gold);
}

.banner-content p {
    font-size: 17px;
    color: var(--text-secondary);
    margin-bottom: 32px;
    line-height: 1.8;
}

.spangold {
    color: #B89468 !important;
}

.banner-buttons {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}

/* 通用区块 */
section {
    padding: 100px 0;
}

.section-title {
    text-align: center;
    margin-bottom: 60px;
}

.section-title h2 {
    font-size: 34px;
    margin-bottom: 12px;
}

.section-title .line {
    width: 64px;
    height: 3px;
    background: linear-gradient(90deg, transparent, var(--gold), transparent);
    margin: 0 auto 16px;
}

.section-title p {
    max-width: 600px;
    margin: 0 auto;
    color: var(--text-secondary);
}

/* 卡片动画 */
.animate-item {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94),
        transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.animate-item.animate-visible {
    opacity: 1;
    transform: translateY(0);
}

.card {
    background: #ffffff11;
    /* border: 1px solid var(--border); */
    border-radius: 12px;
    padding: 32px 24px;
    margin: 16px;
    transition: 0.4s ease;
    backdrop-filter: blur(6px);
    text-align: center;
}

.card:hover {
    transform: translateY(-6px);
    border-color: rgba(184, 148, 104, 0.35);
    background: rgba(201, 224, 245, 0.35);
}

.advantage-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    .icon {
        font-size: 46px;
        width: 80px;
        height: 80px;
        margin: 0 auto;
        border-radius: 50%;
        background: #ffffff11;
        display: flex;
        justify-content: center;
    }
}

.service-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.flow-wrap {
    display: flex;
}

.flow-item {
    height: auto;
    background: #ffffff11;
    border-radius: 12px;
    padding: 20px;
    /* text-align: center; */
    margin: 10px;

}

.form-row {
    width: 100%;
    height: 450px;
    display: flex;
}

.form-row-item {
    width: 100%;
    height: 450px;
    border: 1px solid #B89468;
    border-radius: 12px;
    margin: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.form-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
}

.form-row-item ::v-deep .el-form {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.form-row-item_btn {
    background: linear-gradient(135deg, #B89468, #D4AF70);
    color: #000 !important;
    border: none;
    border-radius: 4px;
    padding: 10px 22px;
    font-weight: 600;
    transition: 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    cursor: pointer;
    margin-top: auto;
}

.form-row-item_btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(184, 148, 104, 0.35);
}

/* ========== 优势 ========== */
.advantage {}

.form-row-item_btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(184, 148, 104, 0.35);
}



/* ========== 底部 ========== */
footer {
    background: rgba(0, 0, 0, 0.3);
    border-top: 1px solid var(--border);
    padding: 60px 0 30px;
}

.footer-grid {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 48px;
    margin-bottom: 40px;
}

.footer-col h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
    color: var(--gold);
}

.footer-col h3 span {
    color: var(--gold);
}

.footer-col p {
    font-size: 14px;
    color: var(--text-secondary);
    line-height: 1.8;
    margin-bottom: 8px;
}

.footer-col a {
    display: block;
    color: var(--text-secondary);
    text-decoration: none;
    font-size: 14px;
    padding: 6px 0;
    transition: 0.3s;
}

.footer-col a:hover {
    color: var(--gold);
    padding-left: 8px;
}

.copyright {
    text-align: center;
    padding-top: 24px;
    border-top: 1px solid var(--border);
    font-size: 13px;
    color: var(--text-secondary);
}

/* ========== 悬浮工具 ========== */
.float-tool {
    position: fixed;
    right: 24px;
    bottom: 80px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    z-index: 999;
}

.float-btn {
    width: 48px;
    height: 48px;
    background: rgba(184, 148, 104, 0.9);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    cursor: pointer;
    transition: 0.3s;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.float-btn:hover {
    transform: scale(1.1);
    background: var(--gold);
    box-shadow: 0 6px 20px rgba(184, 148, 104, 0.5);
}


.hotel-index-page {
    background: linear-gradient(135deg, #0F172A 0%, #1C2D41 100%);
    color: var(--text);
    line-height: 1.6;
    position: relative;
}

.particles-canvas {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
}
</style>